/**
 * Sort two numbers `date1` and `date2` that are potentially `null` or `undefined`.
 *
 * To achieve this, the dates are converted to numbers (if possible) and then passed to `sortNullishNumbers`.
 */
export default (date1: Date | null | undefined, date2: Date | null | undefined, type: 'asc' | 'desc' = 'asc') => sortNullishNumbers(date1?.getTime(), date2?.getTime(), type)
